import { render, staticRenderFns } from "./TokenExpired.vue?vue&type=template&id=52c5de39&scoped=true"
import script from "./TokenExpired.vue?vue&type=script&lang=js"
export * from "./TokenExpired.vue?vue&type=script&lang=js"
import style0 from "./TokenExpired.vue?vue&type=style&index=0&id=52c5de39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5de39",
  null
  
)

export default component.exports